

























































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IRussiaResortRegion, RussiaResortCity } from '../plugins/store.russiaResort';
import DateSelectorComponent from '@/components/DateSelectorComponent.vue';
import ResortHistoryChart from '@/russiaResort/ResortHistoryChart.vue';

@Component({
	components: {
		DateSelectorComponent,
		ResortHistoryChart,
	},
})
export default class RussiaResortRegionTable extends Vue {
	public regionsTableOptions = {
		search: '',
		itemsPerPage: -1,
		headers:
			[{
				text: 'Регион проживания',
				value: 'name',
			},
			{
				text: 'Кол-во',
				value: 'count',
				align: 'end',
			},
			{
				text: 'Изменения',
				value: 'prevCount',
				align: 'end',
			}],
	};
	public citiesTableOptions = {
		search: '',
		itemsPerPage: -1,
		headers:
			[{
				text: 'Курорт',
				value: 'name',
			},
			{
				text: 'Кол-во',
				value: 'cityCount',
				align: 'end',
			},
			{
				text: 'Изменения',
				value: 'prevCityCount',
				align: 'end',
			}],
	};

	public get regionsStat() {
		return this.$store.getters['russiaResort/getSummaryRegionStat'];
	}
	public get cityStat() {
		const cities = this.$store.getters['russiaResort/getSelectedRegion'].russiaResortCities as RussiaResortCity[];
		return cities.map((v) => {
			v.prevCityCount = v.cityCount - v.prevCityCount;
			return v;
		});
	}

	public get regions(): IRussiaResortRegion[] {
		return this.$store.getters['russiaResort/getRegions'];
	}

	public selected: number | undefined = this.$store.getters['russiaResort/getRegionId'];

	public get routeName() {
		return this.$route.name;
	}
	public created() {
		if (this.routeName === 'resortRegionPreview' || this.routeName === 'resortRegionMap') {
			this.selected = +this.$route.params.code;
		} else if (this.routeName === 'resort') {
			this.selected = -1;
		}
	}

	@Watch('regions', { deep: true })
	private onRegionsChange(val) {
		if (this.routeName === 'resortRegionPreview' || this.routeName === 'resortRegionMap') {
			this.onSelectChange(this.selected, this.selected);
		}
	}

	@Watch('selected')
	private onSelectChange(val: number | undefined, oldVal: number | undefined) {
		if (val === 0) {
			this.selected = -1;
		}
		if (val !== undefined && val >= 0) {
			const region = this.regions.find((r) => r.code === val);
			if (region) {
				this.$store.dispatch('russiaResort/updateRegionId', region.code);
				if (this.routeName === 'resortRegionPreview' || this.routeName === 'resortRegionMap') {
					if (+this.$route.params.code !== this.selected) {
						this.$router.push({ name: this.routeName, params: { code: region.code + '' } });
					}
				} else if (this.routeName === 'resort') {
					this.$router.push({ name: 'resortRegionPreview', params: { code: region.code + '' } });
				}
			}
		} else {
			this.$store.dispatch('russiaResort/updateRegionId', -1);
			if (this.routeName !== 'resort') {
				this.$router.push({ name: 'resort' });
			}
		}
	}

	@Watch('$route', { deep: true })
	private onRouteChange(val, oldVal) {
		if (this.routeName === 'resortRegionPreview' || this.routeName === 'resortRegionMap') {
			this.selected = +val.params.code;
		} else if (this.routeName === 'resort') {
			this.selected = -1;
		}
	}
}
